module.exports = __webpack_public_path__ + "static/media/serenedry-2.c9b0e6ea.png";